import Exception from './exception.vue';
export default Exception;


// WEBPACK FOOTER //
// ./src/components/exception/index.js